import React from "react";
import AvatarBadge from "../../utils/AvatarBadge";
import emptyAvatar from "../../../../../images/employeeSpotlightTabs.png";

const EconomicCircleMemberCard = ({ member }) => {
  if (!member) {
    return (
      <div className="flex flex-column align-items-center justify-content-center h-full">
        <img src={emptyAvatar} alt="Empty Avatar" className="w-full object-contain" />
      </div>
    );
  }

  return (
    <>
      <AvatarBadge avatar={member.urlavatar} name={member.node} />
      <div className="text-sm font-medium truncate mb-1" style={{ color: "var(--theme-text)" }}>
        {member.node}
      </div>
      <div
        className="text-xs uppercase font-semibold mb-2"
        style={{ color: "var(--theme-text-muted)" }}
      >
        {member.plan || "-"}
      </div>
      <div
        className="text-xs"
        style={{ color: "color-mix(in srgb, var(--theme-text) 50%, transparent)" }}
      >
        {member.level}
      </div>
    </>
  );
};

export default EconomicCircleMemberCard;
